<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">{{ $t('rulesForm.editCompensationTitle') }}</h2>
            <p class="text-muted small mb-0">{{ $t('rulesForm.editCompensationSub') }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body">
          <form class="forms-sample" method="post" @submit.prevent="submitForm">
            <div class="form-group row">
              <div class="col-md-6 mb-3">
                <label for="nameInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.compensationName') }}</label>
                <input
                  id="nameInput"
                  type="text"
                  class="form-control"
                  v-model="ruleStore.name"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: Sesi Berbagi Pengetahuan 10 Menit' : 'e.g. 10-Minute Knowledge Sharing Session'"
                  required
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="descriptionInput" class="text-muted small text-uppercase font-weight-bold">{{ $t('rulesForm.compensationDesc') }}</label>
                <textarea
                  id="descriptionInput"
                  class="form-control"
                  rows="3"
                  v-model="ruleStore.description"
                  :placeholder="$currentLocale === 'id' ? 'Jelaskan detail tugas pemulihan atau penebusan ini...' : 'Describe the details of this recovery or compensation task...'"
                ></textarea>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2">
              <button type="button" @click="back" class="btn btn-outline-secondary px-4 py-2 mr-2" :disabled="loading">
                {{ $t('common.back') }}
              </button>
              <button type="submit" class="btn btn-primary px-4 py-2 font-weight-bold" :disabled="loading">
                <span class="spinner-border spinner-border-sm mr-1" v-if="loading" role="status"></span>
                <i class="mdi mdi-check-all mr-1" v-else></i>
                {{ $t('common.save') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailCompensation, updateCompensation } from "../../services/compensationService";
import Swal from 'sweetalert2';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    ruleStore: {
      name: '',
      description: '',
    },
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    async submitForm() {
      try {
        this.loading = true;
        await updateCompensation(this.id, this.ruleStore);
        Swal.fire({
          icon: "success",
          title: this.$t('common.success'),
          text: this.$t('rulesForm.updatedSuccess'),
          confirmButtonColor: "#3b82f6",
        });

        this.$router.push('/rules/compensations');
      } catch (error) {
        console.error(error);
        const errMsg = error.response?.data?.message || (this.$currentLocale === 'id' ? 'Gagal menyimpan perubahan tugas kompensasi.' : 'Failed to update compensation task.');
        Swal.fire({
          icon: 'error',
          title: this.$t('common.error') || (this.$currentLocale === 'id' ? 'Terjadi Kesalahan' : 'Error'),
          text: errMsg,
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchCompensation() {
      try {
        const response = await getDetailCompensation(this.id);
        this.ruleStore.name = response.data.name || '';
        this.ruleStore.description = response.data.description || '';
      } catch (err) {
        console.error('Error fetching compensation details:', err);
      }
    },
  },
  mounted() {
    this.fetchCompensation();
  }
};
</script>
